import { Slider } from 'antd'
import { usePointCloudContext } from 'features/pointClouds'
import {
  SliderContainer,
  SliderLabel,
  SliderRow,
  SliderValue,
} from 'pages/pointClouds/components/hud/controlPanel/ControlPanel.styles'
import React from 'react'

export const EDLSettings: React.FC = () => {
  const { edlRadius, edlStrength, setEdlRadius, setEdlStrength } =
    usePointCloudContext()
  return (
    <>
      <SliderRow>
        <SliderLabel>
          Outline Strength: <SliderValue>{edlStrength.toFixed(1)}</SliderValue>
        </SliderLabel>
        <SliderContainer>
          <Slider
            value={edlStrength}
            min={50}
            max={500}
            onChange={(value) => setEdlStrength(value)}
          />
        </SliderContainer>
      </SliderRow>

      <SliderRow>
        <SliderLabel>
          Outline Radius: <SliderValue>{edlRadius.toFixed(2)}</SliderValue>
        </SliderLabel>
        <SliderContainer>
          <Slider
            value={edlRadius}
            min={1}
            max={3}
            step={0.1}
            onChange={(value) => setEdlRadius(value)}
          />
        </SliderContainer>
      </SliderRow>
    </>
  )
}
